import { KTIcon } from '@/_metronic/helpers'
import {useListView} from '../../../core/ListViewProvider'
import { useCustomerListView } from '../../../core/CustomerListViewProvider'

const SubscriptionCustomerModalHeader = () => {
  const {itemId, setItemId} = useCustomerListView()

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>View Subscription Customer Detail</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() => setItemId!(undefined!)}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {SubscriptionCustomerModalHeader}
